import { render } from "./katrina-series-hero.vue?vue&type=template&id=3ad5d269&scoped=true"
import script from "./katrina-series-hero.vue?vue&type=script&lang=js"
export * from "./katrina-series-hero.vue?vue&type=script&lang=js"

import "./katrina-series-hero.vue?vue&type=style&index=0&id=3ad5d269&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad5d269"]])

export default __exports__